import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function ScedCatalog(cipCatalog) { // Ensure correct prop handling
  const [openPanels, setOpenPanels] = useState([]); // Track open panels by courseCode

  // Extract scedCodes, scedNames, and scedDescs from cipCatalog
  const scedCodes = cipCatalog.cipCatalog?.scedCodes || [];
  const scedNames = cipCatalog.cipCatalog?.scedName || [];
  const scedDescs = cipCatalog.cipCatalog?.scedDesc || [];

  // Function to toggle panel open/close using courseCode
  const togglePanel = (code) => {
    setOpenPanels((prev) =>
      prev.includes(code)
        ? prev.filter((c) => c !== code) // Close panel if it's already open
        : [...prev, code] // Open panel if it's closed
    );
  };

  return (
    <div className="w-full px-4">
      <header className="text-sky-700 font-semibold">State Course Codes (Appendix V)</header>
      <div className="mx-auto w-full rounded-2xl p-2">
        {scedCodes.length > 0 ? (
          scedCodes.map((code, index) => {
            const isOpen = openPanels.includes(code);
            return (
              <div key={`${code}-${index}`} className="mt-2">
                {/* Button to toggle panel */}
                <button
                  className={`
                    flex w-full justify-between px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-slate-500 focus-visible:ring-opacity-75
                    ${
                      isOpen
                        ? 'border-t-2 border-x-2 border-slate-200 bg-slate-200 text-slate-900 rounded-t-lg'
                        : 'hover:bg-slate-100 rounded-lg border-t-2 border-x-2 border-transparent bg-slate-100 text-slate-900'
                    }
                    transition-colors duration-150
                  `}
                  onClick={() => togglePanel(code)}
                >
                  <div className="space-x-3">
                    <span className={`${isOpen ? 'text-slate-900' : 'text-slate-600'} tabular-nums`}>
                      {code}
                    </span>
                    <span className={`${isOpen ? 'text-slate-900' : 'text-slate-900'} font-normal`}>
                      {scedNames[index]}
                    </span>
                  </div>
                  <div className={`h-5 w-5 text-slate-500 transform ${isOpen ? 'rotate-180 text-slate-900' : ''} transition-transform duration-150`}>
                    {isOpen ? (
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z" clipRule="evenodd" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                      </svg>
                    )}
                  </div>
                </button>

                {/* Animated Panel */}
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <div className="pb-5 px-4 pt-2 text-sm bg-white text-gray-800 border border-t-0 border-slate-200 rounded-b-lg rounded-t-none">
                        {scedDescs[index]}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })
        ) : (
          <div className="text-center text-gray-500">No SCED Codes Available</div>
        )}
      </div>
    </div>
  );
}